import { render, staticRenderFns } from "./ConsumerProfilePropertyList.vue?vue&type=template&id=18872aba&"
import script from "./ConsumerProfilePropertyList.vue?vue&type=script&lang=js&"
export * from "./ConsumerProfilePropertyList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports